import { render, staticRenderFns } from "./NieuwBericht.vue?vue&type=template&id=3c31993a&"
import script from "./NieuwBericht.vue?vue&type=script&lang=js&"
export * from "./NieuwBericht.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports